import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { ToastContainer } from "react-toastify";
import "react-phone-number-input/style.css";
import "react-phone-number-input/mobile";
import TableContainer from "../../../Components/Common/TableContainer";
import CertificationBadge from "../../../Components/Common/CertificationBadge";
import {
  CERTIFICATION_LEVEL_OPTIONS,
  getCertificationMeta,
} from "../../../constants/certification";
import Loader from "../../../Components/Common/Loader";
import UserProfileAvatarWithFallback from "../../../Components/Common/UserProfileAvatarWithFallback";
import {
  useCertifyProfessional,
  useProfessionals,
} from "../../../hooks/useProfessionals";

//redux

const Certification = (props) => {
  document.title = props.t("Certification| Le Conseiller du BTP");
  const DEFAULT_USER_AVATAR =
    "https://prod.leconseillerdubtp.com/medias/default/user.png";

  const professionalsQ = useProfessionals();
  const certifyProfessional = useCertifyProfessional({ method: "put" });

  const professionalsRaw = professionalsQ.data || [];
  const professionalsList = Array.isArray(professionalsRaw)
    ? professionalsRaw
    : professionalsRaw?.results || [];

  const [certifyModalOpen, setCertifyModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [certificateValue, setCertificateValue] = useState(1);

  const openCertifyModal = (user) => {
    setSelectedUser(user);
    const existing = user?.professional?.banca_certificate;
    const initialValue =
      typeof existing === "number" && Number.isFinite(existing) ? existing : 1;
    setCertificateValue(initialValue);
    setCertifyModalOpen(true);
  };

  const submitCertification = async () => {
    const professionalId = selectedUser?.professional?.id;
    if (!professionalId) return;

    await certifyProfessional.mutateAsync({
      id: professionalId,
      payload: { banca_certificate: Number(certificateValue) },
    });
    setCertifyModalOpen(false);
    setSelectedUser(null);
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const handleDeleteProduct = () => {
    if (professionalsList) {
      // dispatch(deleteProducts(articles.id));
      setDeleteModal(false);
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      // dispatch(deleteProducts(element.value));
      del.style.display = "none";
    });
  };

  const columns1 = useMemo(
    () => [
      {
        Header: props.t("IMAGE"),
        accessor: "profile_pic",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <UserProfileAvatarWithFallback
                  picture={recruitments.row.original?.profile?.profile_pic}
                  name={
                    recruitments.row.original?.username ||
                    recruitments.row.original?.email
                  }
                  defaultUrl={DEFAULT_USER_AVATAR}
                  t={props.t}
                />
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("NOM"),
        accessor: "last_name",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center ">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1 italic"
                  style={{ textTransform: "uppercase", fontWeight: "bold" }}
                >
                  <span className="text-dark">
                    {recruitments.row.original?.profile?.last_name ||
                      (recruitments.row.original?.username
                        ? recruitments.row.original.username
                            .trim()
                            .split(/\s+/)
                            .slice(1)
                            .join(" ")
                        : "") ||
                      "-"}
                  </span>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("PRENOM(S)"),
        accessor: "first_name",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center ">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1 italic"
                  style={{ fontWeight: "bold" }}
                >
                  <span className="text-dark">
                    {recruitments.row.original?.profile?.first_name ||
                      (recruitments.row.original?.username
                        ? recruitments.row.original.username
                            .trim()
                            .split(/\s+/)[0]
                        : "") ||
                      "-"}
                  </span>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("EMAIL"),
        accessor: "email",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 uppercase">
                  {recruitments.row.original.email}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("TELEPHONE"),
        accessor: "phone_number",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 uppercase">
                  {recruitments.row.original.phone_number}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("TYPE"),
        accessor: "user_type",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 uppercase">
                  {recruitments.row.original?.profile?.user_type ===
                  "particular" ? (
                    <h5 className="badge badge-soft-danger">Particulier</h5>
                  ) : recruitments.row.original?.profile?.user_type ===
                    "assistant" ? (
                    <h5 className="badge badge-soft-primary">Assistant</h5>
                  ) : recruitments.row.original?.profile?.user_type ===
                    "professional" ? (
                    <h5 className="badge badge-soft-info">Professionnel</h5>
                  ) : recruitments.row.original?.profile?.user_type ===
                    "expert" ? (
                    <h5 className="badge badge-soft-secondary">Expert</h5>
                  ) : recruitments.row.original?.profile?.user_type ===
                    "commite" ? (
                    <h5 className="badge badge-soft-secondary">Commité</h5>
                  ) : recruitments.row.original?.profile?.user_type ===
                    "enterprise" ? (
                    <h5 className="badge badge-soft-secondary">Entreprise</h5>
                  ) : recruitments.row.original?.profile?.user_type ===
                    "organism" ? (
                    <h5 className="badge badge-soft-secondary">Organisme</h5>
                  ) : (
                    ""
                  )}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t(" "),
        accessor: "",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <CertificationBadge
                  professional={recruitments.row.original.professional}
                />
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const articlesData = cellProps.row.original;
          return (
            <>
              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/profile-users/${articlesData.id}/`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>
              {articlesData?.professional?.id ? (
                <li className="list-inline-item" title={props.t("Certifier")}>
                  <Button
                    type="button"
                    size="sm"
                    color="success"
                    outline
                    disabled={certifyProfessional.isPending}
                    onClick={() => openCertifyModal(articlesData)}
                  >
                    {props.t("Certifier")}
                  </Button>
                </li>
              ) : null}
            </>
          );
        },
      },
    ],
    [props, certifyProfessional.isPending]
  );

  document.title = props.t("Liste des utilisateurs professionnels");

  if (professionalsQ.isLoading) {
    return <Loader />;
  }

  if (professionalsQ.isError) {
    return (
      <Loader
        error={
          professionalsQ.error?.message || props.t("Erreur lors du chargement")
        }
      />
    );
  }

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProduct}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Liste des utilisateurs professionnels du BTP")}
          pageTitle={props.t("Listes des utilisateurs professionnels du BTP")}
        />
        <Modal
          isOpen={certifyModalOpen}
          toggle={() => setCertifyModalOpen(false)}
        >
          <ModalHeader toggle={() => setCertifyModalOpen(false)}>
            {props.t("Certification")}
          </ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label" htmlFor="certification-level">
                {props.t("Niveau de certification")}
              </label>
              <Input
                id="certification-level"
                type="select"
                className="form-select"
                value={certificateValue}
                onChange={(e) => setCertificateValue(e.target.value)}
              >
                {CERTIFICATION_LEVEL_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
              <small className="text-muted">
                {getCertificationMeta(certificateValue).description}
              </small>
              {Number(certificateValue) === 0 ? (
                <div className="alert alert-warning mt-2 mb-0 fs-12">
                  <i className="ri-alert-line align-bottom me-1"></i>
                  {props.t(
                    "Le niveau 0 retire la certification de ce professionnel."
                  )}
                </div>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="secondary"
              onClick={() => setCertifyModalOpen(false)}
            >
              {props.t("Annuler")}
            </Button>
            <Button
              type="button"
              color="success"
              onClick={submitCertification}
              disabled={certifyProfessional.isPending}
            >
              {props.t("Valider")}
            </Button>
          </ModalFooter>
        </Modal>
        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-header border-0">
                  <Row className="g-4 align-items-center">
                    <Col sm={4}>
                      <div className="search-box">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder="Rechercher..."
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </Col>
                  </Row>
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <div id="selection-element">
                        <div className="my-n1 d-flex align-items-center text-muted">
                          Select{" "}
                          <div
                            id="select-content"
                            className="text-body fw-semibold px-1"
                          >
                            {}
                          </div>{" "}
                          Result{" "}
                          <button
                            type="button"
                            className="btn btn-link link-danger p-0 ms-3"
                            onClick={() => setDeleteModalMulti(true)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  {professionalsList && professionalsList.length >= 0 ? (
                    <TableContainer
                      columns={columns1}
                      data={professionalsList || []}
                      isAddUserList={false}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="mb-0 align-middle "
                      theadClass="table-light text-muted"
                      isMetierFilter={false}
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5> {props.t("Désolé, pas de resultats trouvés")} </h5>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

Certification.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Certification));
